<template>
  <div ref="floatingWindow" class="floating-window" :style="{ top: top + 'px', left: left + 'px', width: width + 'px', height: height + 'px' }">
    <div class="resize-handle bottom-right" @mousedown="startResize"></div>

    <div class="title-bar" @mousedown="startDrag" :style="{ background: headerBg, color: headerColor }">
      <span>{{ title }}</span>
      <button @click="closeWindow" class="closeWin">X</button>
    </div>

    <div class="content" :style="{ pointerEvents: (dragging || resizing) ? 'none' : 'auto' }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: "代码编辑器" },
    headerBg: { type: String, default: "#f0f0f0" },
    headerColor: { type: String, default: "#333" },

    initWidth: { type: Number, default: 700 },
    initHeight: { type: Number, default: 600 },
    minWidth: { type: Number, default: 300 },
    minHeight: { type: Number, default: 40 },

    position: { type: String, default: "right-bottom" },
    onClose: { type: Function, default: () => { } }
  },
  data () {
    return {
      dragging: false,
      resizing: false,
      startX: 0,
      startY: 0,
      startWidth: 0,
      startHeight: 0,
      top: 80,
      left: 300,
      width: this.initWidth,
      height: this.initHeight,
      headerH: 40
    };
  },
  mounted () {
    this.initPosition();
  },
  methods: {
    initPosition () {
      const sw = window.innerWidth;
      const sh = window.innerHeight;
      const gap = 20;
      switch (this.position) {
        case "left-top":
          this.left = gap; this.top = gap; break;
        case "right-top":
          this.left = sw - this.width - gap; this.top = gap; break;
        case "left-bottom":
          this.left = gap; this.top = sh - this.height - gap; break;
        default:
          this.left = sw - this.width - gap; this.top = sh - this.height - gap; break;
      }
    },

    startDrag (e) {
      e.preventDefault()
      this.dragging = true;
      this.startX = e.clientX - this.left;
      this.startY = e.clientY - this.top;
      window.addEventListener('mousemove', this.drag);
      window.addEventListener('mouseup', this.stopDrag);
    },
    startResize (e) {
      e.preventDefault()
      this.resizing = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.startWidth = this.width;
      this.startHeight = this.height;
      window.addEventListener('mousemove', this.resize);
      window.addEventListener('mouseup', this.stopResize);
    },

    drag (e) {
      if (!this.dragging) return
      let newLeft = e.clientX - this.startX
      let newTop = e.clientY - this.startY

      const winW = window.innerWidth

      // 🔴 顶部、左右 死死锁住，绝不出去
      newTop = Math.max(0, newTop)
      newLeft = Math.max(0, newLeft)
      newLeft = Math.min(newLeft, winW - this.width)

      // 🟢 底部完全放开！随便拖出屏幕下方
      this.top = newTop
      this.left = newLeft
    },

    resize (e) {
      if (!this.resizing) return
      let newW = this.startWidth + (e.clientX - this.startX)
      let newH = this.startHeight + (e.clientY - this.startY)
      const winW = window.innerWidth

      newW = Math.max(this.minWidth, newW)
      newH = Math.max(this.headerH, newH)

      newW = Math.min(newW, winW - this.left)
      // 高度不限制底部，无限拉长溢出屏幕

      this.width = newW
      this.height = newH
    },

    stopDrag () {
      this.dragging = false
      window.removeEventListener('mousemove', this.drag)
      window.removeEventListener('mouseup', this.stopDrag)
    },
    stopResize () {
      this.resizing = false
      window.removeEventListener('mousemove', this.resize)
      window.removeEventListener('mouseup', this.stopResize)
    },

    closeWindow () {
      this.onClose();
    }
  }
};
</script>

<style scoped>
.floating-window {
  position: absolute;
  background: #fff;
  border: 1px solid #ccc;
  z-index: 9999;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: visible; /* 底部内容溢出不裁剪 */
}

.title-bar {
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  cursor: move;
  user-select: none;
  flex: 0 0 40px; /* 标题永远不被挤压 */
}

.resize-handle {
  width: 10px;
  height: 10px;
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: nwse-resize;
  background: #ccc;
  z-index: 99;
}

.content {
  flex: 1; /* 自动撑满剩余高度，不留空白 */
  padding: 8px;
}

.closeWin {
  float: right;
  border: none;
  background: transparent;
  cursor: pointer;
}
</style>